export const drawerItemsMain = [
  {
    key: "Containers Management",
    title: "containersStatus",
    routes: [
      {
        nav: "ContainersManagement",
        routeName: "ContainersManagement",
        title: "containersStatus",
      },
    ],
  }
];
